<template>
    <section class="app-main">
        <h2>&nbsp;</h2>
        <transition name="fade-transform" mode="out-in">
            <keep-alive>
                <router-view :key="key" />
            </keep-alive>
        </transition>
    </section>
</template>

<script>
export default {
    name: "AppMain",
    computed: {
        key() {
            return this.$route.fullPath;
        }
    }
};
</script>
